<template>
  <span>
    <span>{{ prependText }}</span>
    <component
      v-if="hasIcon"
      :is="preview.icon"
      class="conversation-item__preview-icon"
    />
    <span>{{ preview.text }}</span>
  </span>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingArrowIcon from '@/assets/icons/loading-arrow.svg';
import ShuffleIcon from '@/assets/icons/shuffle.svg';
import TypeAudioIcon from '@/assets/icons/type-audio.svg';
import TypeDocumentIcon from '@/assets/icons/type-document.svg';
import TypeImageIcon from '@/assets/icons/type-image.svg';
import TypeLocationIcon from '@/assets/icons/type-location.svg';
import TypeVideoIcon from '@/assets/icons/type-video.svg';

export default {
  components: {
    LoadingArrowIcon,
    ShuffleIcon,
    TypeAudioIcon,
    TypeDocumentIcon,
    TypeImageIcon,
    TypeLocationIcon,
    TypeVideoIcon,
  },
  props: {
    clientId: {
      type: String,
      default: '',
    },
    message: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters([
      'chatCurrentInput',
    ]),
    ...mapState({
      activeClientId: (state) => state.activeClientId,
    }),
    isActive() {
      return this.clientId === this.activeClientId;
    },
    draftText() {
      return this.chatCurrentInput(this.clientId);
    },
    hasDraft() {
      return this.draftText.trim() !== '';
    },
    showDraft() {
      return this.hasDraft && !this.isActive;
    },
    isDocument() {
      return !!this.message && !!this.message.multimedia && this.message.type === 'document';
    },
    documentText() {
      if (this.isDocument) {
        const filename = this.message.multimedia.filename ?? '';

        return filename.length > 0 ? filename : this.$t('conversation.document');
      }

      return this.$t('conversation.document');
    },
    isLocation() {
      return !!this.message && !!this.message.location && this.message.type === 'location';
    },
    locationText() {
      if (this.isLocation) {
        const loc = this.message.location.name ?? '';

        return loc.length > 0 ? loc : this.$t('conversation.location');
      }

      return this.$t('conversation.location');
    },
    prependText() {
      if (this.showDraft) {
        return `${this.$t('conversation.draft')}: `;
      }

      if (!!this.message && this.message.typeUser === 'User') {
        return `${this.$t('conversation.you')}: `;
      }

      return '';
    },
    preview() {
      let text = '';
      let icon = '';

      if (this.message) {
        switch (this.message.type) {
          case 'tImage':
          case 'image':
            text = this.$t('conversation.image');
            icon = 'type-image-icon';
            break;
          case 'audio':
          case 'voice':
            text = this.$t('conversation.audio');
            icon = 'type-audio-icon';
            break;
          case 'video':
            text = this.$t('conversation.video');
            icon = 'type-video-icon';
            break;
          case 'location':
            text = this.locationText;
            icon = 'type-location-icon';
            break;
          case 'document':
            text = this.documentText;
            icon = 'type-document-icon';
            break;
          case 'transfer':
            text = this.$t('conversation.transfer');
            icon = 'shuffle-icon';
            break;
          case 'statusChange':
            text = this.$t('conversation.status');
            icon = 'loading-arrow-icon';
            break;
          case 'text':
          case 'tText':
            text = this.showDraft ? this.draftText : this.message.text.trim();
            icon = '';
            break;
          default:
            text = '';
            icon = '';
            break;
        }
      }

      return {
        text,
        icon,
      };
    },
    hasIcon() {
      return this.preview.icon !== '';
    },
  },
};
</script>
